import { z } from "zod";

export type MessageAction = z.infer<typeof MessageActionSchema>;
export const MessageActionSchema = z.object({
  is_hidden: z.boolean().nullable(),
  report_status: z.string().nullable(),
});
